<template>
    <!-- <div class='template_wrapper'>
        <span class="template_title">{{moduel.name}}</span>
        <el-input
            type="textarea"
            :rows="2"
            size="small"
            resize="none"
            placeholder="请输入内容"
            v-model="name"
            @change="textChange">
        </el-input>
        <span style="color:red;" v-if="moduel.required==1" >*</span>
         <span v-if="moduel.required!=1" >选填</span> -->
    <!-- </div> --> 
    <div class="template_wrapper">
      <div class="template_title" style="vertical-align: top;"><span style="color:red;vertical-align: top;" v-if="moduel.required==1" >*</span>{{moduel.name}}</div>
        <el-input
          type="textarea"
          :rows="5"
          size="small"
          resize="none"
          placeholder="请输入内容"
          v-model="content"
          @change="textChange">
        </el-input>
      <span v-if="moduel.key_name == 'workday'">天</span>
      <!-- <span style="color:red;vertical-align: top;" v-if="moduel.required==1&& type!='audit'" >*</span> -->
    </div>
</template>
<style>
</style>
<script>
export default {
  data () {
    return {
        content:'',
        key_name:'',
       disabled:false
    }
  },
  props: ['moduel','projectData',"type"],
  methods:{
    clear(){
      this.content = '';
    },
    textChange(){
      // console.log(this.name)
      this.$emit('input',this.content);
      this.$emit('listenToChildEvent');
    }
  },
   beforeDestroy (){
      this.clear();
  },
  mounted() {
    if(this.projectData[this.moduel.key_name] != ''){
      this.disabled = true;
      if(this.projectData[this.moduel.key_name] !=null){
        this.content = this.projectData[this.moduel.key_name];
      }
    }
    this.$emit('input', this.projectData[this.moduel.key_name])
  },
  watch: {
    'content':{
      handler(newName, oldName) {
        var that =this;
        this.$nextTick(function(){
          this.$emit('input',this.content);
          this.$emit('listenToChildEvent',this.type);
        });
      },
      immediate: true
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/c-text.vue